import { render, staticRenderFns } from "./c-phone-item.vue?vue&type=template&id=178f89c6&scoped=true"
import script from "./c-phone-item.vue?vue&type=script&lang=js"
export * from "./c-phone-item.vue?vue&type=script&lang=js"
import style0 from "./c-phone-item.vue?vue&type=style&index=0&id=178f89c6&prod&lang=less"
import style1 from "./c-phone-item.vue?vue&type=style&index=1&id=178f89c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f89c6",
  null
  
)

export default component.exports